import { render, staticRenderFns } from "./BrAdminNotesComposer.vue?vue&type=template&id=be093742&scoped=true&"
import script from "./BrAdminNotesComposer.vue?vue&type=script&lang=js&"
export * from "./BrAdminNotesComposer.vue?vue&type=script&lang=js&"
import style0 from "./BrAdminNotesComposer.vue?vue&type=style&index=0&id=be093742&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be093742",
  null
  
)

export default component.exports